import { createFileRoute } from '@tanstack/react-router';

import { OperationChecksReadonly } from '../../features/operations/operation-checks-readonly';
import { OperationDetailShell } from '../../features/operations/operation-detail-shell';
import { operationDetailQueryOptions } from '../../features/operations/queries';

export const Route = createFileRoute('/operations/$operation_id_/checks')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { operation_id: operationId } = match.params as { operation_id: string };
      const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
      return data ? `${data.operation_name} — Checks` : 'Operation Checks';
    },
    layout: 'full-height',
  },
  component: OperationChecksPage,
});

function OperationChecksPage() {
  const { operation_id: operationId } = Route.useParams();

  return (
    <OperationDetailShell operationId={operationId} active="checks">
      {(operation) => (
        <div className="flex flex-col gap-3 p-6">
          <p className="text-muted-foreground text-sm">
            Pre-flight and in-process checks defined for this operation. Editing checks is not yet
            supported in Quality — use the Hub Operations page to modify these.
          </p>
          <OperationChecksReadonly
            preFlightChecks={operation.operation_pre_flight_checks}
            inProcessChecks={operation.operation_in_process_checks}
          />
        </div>
      )}
    </OperationDetailShell>
  );
}
